import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { useDispatch } from 'react-redux';

import Form from '@gef-ui/form-material/Form';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import Panel from 'components/atoms/GefMui/Panel';
import Subheader from 'components/atoms/GefMui/Subheader/Subheader';
import PAGES from 'constants/pages';
import { urls } from 'features/common/fetch/constants';
import { useRenderSubheaderTitle } from 'features/common/Subheader/hooks';
import { fetchDocumentDetail, fetchFinalStates } from 'features/views/productionControlDetail/actions';
import { fetchDocumentDetailNotices } from 'features/views/productionControlDetail/notice/actions';
import formDescriptorFn, { NOTICES_FORM_NAME } from 'features/views/productionControlDetail/notice/form';
import { resetProductionControlDetail } from 'features/views/productionControlDetail/slice';

import ActionButtons from './components/ActionButtons';
import ConsultantInfo from './components/ConsultantInfo';
import DocumentInfo from './components/DocumentInfo';
import Notices from './components/Notices';

export const ProductionControlDetail = ({ documentId }) => {
	const dispatch = useDispatch();

	const subheaderTitle = useRenderSubheaderTitle({
		pageTitle: getLabelMessage('productionControlDetail:productionControlDetailMainTitle'),
		backButton: true,
	});

	useEffect(() => {
		dispatch(fetchDocumentDetail(documentId));
		dispatch(fetchDocumentDetailNotices(documentId));
		dispatch(fetchFinalStates());
	}, [dispatch, documentId]);

	useEffect(
		() => () => {
			dispatch(resetProductionControlDetail());
		},
		[dispatch],
	);

	return (
		<ComponentLoader fetchStorePath={urls.koprDetail}>
			<ComponentLoader fetchStorePath={urls.koprDetailNotices}>
				<Panel screenId={PAGES.productionControlDetail.id} screenName={PAGES.productionControlDetail.name}>
					<Paper sx={{ p: 3, borderRadius: 2 }}>
						<Stack spacing={2}>
							<Subheader title={subheaderTitle} headerToolbar={<ActionButtons />} />
							<DocumentInfo />
						</Stack>
					</Paper>
					<ConsultantInfo />
					<Form name={NOTICES_FORM_NAME} formDescriptorFn={formDescriptorFn}>
						<Notices />
					</Form>
				</Panel>
			</ComponentLoader>
		</ComponentLoader>
	);
};

ProductionControlDetail.propTypes = {
	documentId: PropTypes.string,
};

export default ProductionControlDetail;
